/** Minimal event hook. analytics.ts subscribes and forwards to PostHog when a project key is configured. */
type Props = Record<string, string | number | boolean | undefined>;
const listeners: ((name: string, props?: Props) => void)[] = [];
export function track(name: string, props?: Props): void {
  for (const l of listeners) l(name, props);
  if (import.meta.env.DEV) console.debug('[event]', name, props ?? '');
}
export function onTrack(l: (name: string, props?: Props) => void): void { listeners.push(l); }
